import { ServiceBase } from '../../../core/services/ServiceBase'
import proxy from './Proxy'

class Service extends ServiceBase {
  getCoachMarks(params) {
    return this.getData(() => proxy.getCoachMarks(params))
  }

  updateCoachMarks(params) {
    return this.getData(() => proxy.updateCoachMarks(params))
  }
}

const service = new Service()
export default service
